import { IAttendee } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

import { Static } from 'core-components/types'
import { Crud } from 'core/types/Crud'

interface IGetParticipantsCrud {
  hpAttendees: IAttendee[]
  accountAttendees: IAttendee[]
}
export const getParticipantsCrud = ({ hpAttendees, accountAttendees }: IGetParticipantsCrud) => {
  return new Crud({
    fetcher: new Static([...hpAttendees, ...accountAttendees]),
    keyField: 'Name',
    defaultPaging: {
      page: 0,
      pageSize: 20,
    },
  })
}
